import { Dropdown, Menu } from 'antd';
import { useCallback, useMemo } from 'react';
import { getFlagCode } from '../../../utils/utils';
import { AvailableLanguages } from '../../../utils/constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLang } from '../../../utils/lang';
import Flag from './flag';

interface Props {
    collapsed: boolean;
}

const LanguageSwitcher = (props: Props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const lang = useLang();

    const changeLanguage = useCallback((newLang: string) => {
        navigate(`/${newLang}${location.pathname.substring(3)}`);
    }, [location.pathname, navigate]);

    const menu = useMemo(() => {
        return (
            <Menu className='language-switcher-menu'>
                {
                    AvailableLanguages.map((item) => (
                        <Menu.Item key={item.value} onClick={e => changeLanguage(e.key)} className={`language-switcher-item ${lang === item.value ? 'selected' : ''}`}>
                            <div style={{ display: 'flex' }}>
                                <span style={{ minHeight: 32 }}><Flag countryCode={item.flag.toLocaleUpperCase()} /></span>
                                <span style={{ margin: 'auto auto auto 10px' }}>{item.label}</span>
                            </div>
                        </Menu.Item>
                    ))
                }
            </Menu>
        );
    }, [changeLanguage, lang]);

    return (
        <>
            {
                props.collapsed ?
                    <div style={{ width: '100%', display: 'flex' }}>
                        {
                            AvailableLanguages.map(item => {
                                return (
                                    <div key={item.value} style={{ margin: 'auto' }} onClick={() => changeLanguage(item.value)}>
                                        <Flag countryCode={item.flag.toLocaleUpperCase()} />
                                    </div>
                                );
                            })
                        }
                    </div>
                    :
                    <Dropdown overlay={menu} placement={'top'} trigger={['click']}>
                        <div onClick={e => { e.preventDefault(); }} style={{ margin: 'auto 12px auto auto', cursor: 'pointer' }}>
                            <Flag countryCode={getFlagCode(lang ? lang : 'fr')} />
                        </div>
                    </Dropdown>
            }
        </>
    );
};

export default LanguageSwitcher;